import React from "react";
import CurrencyFormatter from "./CurrencyFormatter";

const TaxCalculator = ({ data }) => {
  // Calculate merged taxes by type across all items
  const calculateMergedTaxes = () => {
    const taxSummary = {};
    if (typeof data.length === "undefined") {
      data = data?.items;
    }
    data.forEach((item) => {
      const itemAmount = item.price * item.quantity;

      item?.taxes?.forEach((tax) => {
        if (!tax?.title || !tax?.rate) return; // Skip invalid tax entries

        if (!taxSummary[tax.title]) {
          taxSummary[tax.title] = {
            rate: tax.rate,
            taxableAmount: 0,
            taxAmount: 0,
          };
        }

        taxSummary[tax.title].taxableAmount += itemAmount;
        taxSummary[tax.title].taxAmount +=
          itemAmount * (parseFloat(tax.rate) / 100);
      });
    });

    return Object.entries(taxSummary).map(([title, data]) => ({
      title,
      rate: data.rate,
      taxableAmount: data.taxableAmount,
      taxAmount: data.taxAmount,
    }));
  };

  const taxes = calculateMergedTaxes();

  if (!taxes.length) {
    return <div></div>;
  }

  return (
    <div className="tax-summary" style={{ minWidth: "200px" }}>
      {taxes.map((tax, index) => (
        <div
          key={`${tax.title}-${index}`}
          className="tax-line"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "10px 0",
          }}
        >
          <span style={{ display: "inline-flex", columnGap: "5px" }}>
            <span>{tax.title}</span>
            <span>{tax.rate}%</span>
          </span>
          <span>
            <CurrencyFormatter value={tax.taxAmount} />
          </span>
        </div>
      ))}
    </div>
  );
};

export default TaxCalculator;
